import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input, DatePicker} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {withTranslation} from 'react-i18next'
import {SendOutlined} from '@ant-design/icons'
import SendFormModal from './SendFormModal'
import {toJS} from 'mobx'
import moment from 'moment'
const storage = window.localStorage

@inject('marketingResourcePoolStore', 'accountStore', 'marketingSmsManagementStore', 'emailListStore', 'intelligentOutboundCallStore')
@observer
class SearchForm extends Component {
  state = {
    selectLoading: false,
    selectOptions: {},
    addModalVisible: false,
    conditions: null,
    idList: null
  }
  formRef = React.createRef()

  componentDidMount() {
    const {marketingResourcePoolStore, accountStore, record, marketGroupId, type} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingResourcePoolStore.onGetJobAction(record?.id).then(res => {
      marketingResourcePoolStore.onSearchListAction({
        'marketGroupId': marketGroupId,
        'poolId': record?.id,
        'taskType': type,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'pageNo': 1,
        'pageSize': PAGE_SIZE_DEFAULT
      }).then(res => {
      })
    })
  }

  handleSearch = () => {
    const {marketingResourcePoolStore, accountStore, record, type} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      marketingResourcePoolStore.onSearchListAction({
        "conditions": this.processConditions(this.transformSearchObject(fieldsValue)),
        'poolId': record?.id,
        'taskType': type,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'pageNo': 1,
        'pageSize': PAGE_SIZE_DEFAULT
      }, true)
    }).catch(err => {
    })
  }

  handleSend = () => {
    const {marketingResourcePoolStore, marketingSmsManagementStore, intelligentOutboundCallStore, emailListStore, accountStore, poolObj, marketGroupId, record, isSelect, handleCancel,type, smsType} = this.props
    const {selectedRowKeys, isAll, selectedPhoneList, selectedEmailList} = marketingResourcePoolStore
    const {generateID} =marketingSmsManagementStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      const conditions = isAll || selectedRowKeys.length===0 ? this.processConditions(this.transformSearchObject(fieldsValue)) : null
      const idList = !isAll && selectedRowKeys.length>0 ? selectedRowKeys : null
      const phoneList = !isAll && selectedPhoneList.length>0 ? selectedPhoneList : null
      const emailList = !isAll && selectedEmailList.length>0 ? selectedEmailList : null
      if(isSelect) {
          marketingResourcePoolStore.onImportAction({
            taskGroupId: generateID,
            poolId: record?.id,
            sourceType: '3',
            taskType: type==='4'? '7' : type,
            smsType: smsType,
            conditions: conditions,
            // idList: idList,
            phoneList,
            emailList,
            listId: poolObj?.id,
            marketGroupId: marketGroupId
          }).then(res=> {
            if (res?.data?.code === 0) {
              if(type==='4') {
                handleCancel()
                intelligentOutboundCallStore.onStatisticsAction(generateID)
                marketingResourcePoolStore.onChangeIsAll(false)
                marketingResourcePoolStore.onClearSelectedRowKeys([],[])
              } else if(smsType==='1') {
                marketingSmsManagementStore.onPhoneAction({
                  'sourceType': '3',
                  'phone': '',
                  'taskGroupId': generateID,
                  'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
                  'page': 1,
                  'size': PAGE_SIZE_DEFAULT
                }).then(resp=>{
                  if(resp?.data?.code ===0) {
                    handleCancel()
                  }
                })
                marketingSmsManagementStore.onStatisticsAction({
                  "smsType": smsType,
                  "taskGroupId": generateID,
                  "taskType": type
                })
              } else if(smsType==='2') {
                marketingSmsManagementStore.onExcelViewAction({
                  "configName": "",
                  "marketGroupId": "",
                  "sourceType": '3',
                  "taskGroupId": generateID,
                  'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
                  'page': 1,
                  'size': PAGE_SIZE_DEFAULT
                }).then(resp=>{
                  if(resp?.data?.code ===0) {
                    handleCancel()
                  }
                })
                marketingSmsManagementStore.onStatisticsAction({
                  "smsType": smsType,
                  "taskGroupId": generateID,
                  "taskType": type
                })
              } else {
                emailListStore.onAddressAction({
                  'email': '',
                  'taskGroupId': generateID,
                  'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
                  'page': 1,
                  'size': PAGE_SIZE_DEFAULT
                }).then(resp=>{
                  if(resp?.data?.code ===0) {
                    handleCancel()
                  }
                })
                emailListStore.onStatisticsAction({
                  "taskGroupId": generateID,
                })
              }
              marketingResourcePoolStore.onChangeIsAll(false)
              marketingResourcePoolStore.onClearSelectedRowKeys([],[])
            }
          })
      } else {
        marketingSmsManagementStore.onGenerateIDAction()
        this.setState({
          addModalVisible: true,
          conditions: conditions,
          idList: idList
        })
      }
    }).catch(err => {
    })
  }
  handleCancelSend = () => {
    this.setState({
      addModalVisible: false,
      conditions: null,
      idList: null
    })
  }
  
  transformSearchObject = obj => {
    const { marketingResourcePoolStore } = this.props;
    const { reportPageCondition } = marketingResourcePoolStore;
    const disposeData = {};
    const result = [...toJS(reportPageCondition)];
  
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (!disposeData[key]) {
          disposeData[key] = '';
        }
        const value = obj[key];
        if (moment.isMoment(value)) {
          disposeData[key] = value.format('YYYY-MM-DD HH:mm:ss');
        } else {
          if (value) {
            disposeData[key] = value;
          }
        }
      }
    }
  
    for (const key in disposeData) {
      if (obj.hasOwnProperty(key)) {
        const parts = key.split('---');
        const middleType = parts[1];
        const index = Number(parts[parts.length - 1]);
  
        // 确保 result[index].value 是一个数组
        if (typeof result[index].value === 'string') {
          try {
            result[index].value = JSON.parse(result[index].value);
          } catch {
            result[index].value = [];
          }
        }
        if (!Array.isArray(result[index].value)) {
          result[index].value = [];
        }
  
        if (middleType.includes('start1716367549959')) {
          result[index].value[0] = disposeData[key]; // 设置起始时间
        } else if (middleType.includes('end1716367549959')) {
          result[index].value[1] = disposeData[key]; // 设置结束时间
        } else {
          result[index].value = disposeData[key]; // 单值字段
        }
      }
    }
  
    result.forEach(item => {
      if (typeof item.value === 'string') {
        item.value = item.value; // 保留字符串
      } else if (Array.isArray(item.value)) {
        item.value = item.value.every(subItem => subItem === '') ? JSON.stringify([]) : JSON.stringify(item.value); // 转为字符串
      } else {
        item.value = JSON.stringify(item.value); // 转为字符串
      }
      delete item.placeholder; // 删除多余的 placeholder
    });
  
    return result;
  };
  processConditions = data => {
    return data.map(item => {
      if (item.type === 'DATE' && item.operator !== 'between') {
        item.value = item.value ? moment(item.value).format('YYYY-MM-DD') : ''
      } else if (item.type === 'DATE' && item.operator === 'between') {
        item.value = item.value ? JSON.stringify(JSON.parse(item.value).map(subItem => subItem !== '' ? moment(subItem).format('YYYY-MM-DD') : '')) : JSON.stringify([])
      }
      return item
    })
  }
  getOptions = (open, name) => {
    const {marketingResourcePoolStore, record} = this.props
    const searchParams = this.formRef.current.getFieldsValue()
    const finalConditions = this.processConditions(this.transformSearchObject(searchParams))

    if (open) {
      this.setState({selectLoading: true})
      marketingResourcePoolStore.getInSearchList({
        poolId: record?.id,
        conditionName: name,
        conditions: finalConditions,
      }).then(res => {
        if (res?.code === 0) {
          this.setState({selectOptions: {...this.state.selectOptions, [name]: res.data?.map(item => ({label: item, value: item}))}})
        }
        this.setState({selectLoading: false})
      }).catch(() => this.setState({selectLoading: false}))
    }
  }
  renderSearchCriteria = () => {
    const { marketingResourcePoolStore } = this.props;
    const { selectOptions, selectLoading } = this.state;
    let searchButtons = false;
    const finalArray = marketingResourcePoolStore.reportPageCondition?.map((item, index) => {
      if (index === 15) searchButtons = true;
      
      const commonProps = {
        key: item?.name + '---' + index,
        label: item?.name,
        initialValue: item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined, // 设置默认值，为空时不填充
      };
  
    // 1. DATETIME 或 TIMESTAMP 且操作符为 between
    if ((item.type === 'DATETIME' || item.type === 'TIMESTAMP') && item.operator === 'between') {
    let startValue = undefined;
    let endValue = undefined;

    if (typeof item.value === 'string' && item.value.trim().startsWith('[') && item.value.trim().endsWith(']')) {
        try {
            const parsedValue = JSON.parse(item.value);
            startValue = parsedValue[0] ? moment(parsedValue[0], 'YYYY-MM-DD HH:mm:ss') : undefined;
            endValue = parsedValue[1] ? moment(parsedValue[1], 'YYYY-MM-DD HH:mm:ss') : undefined;
        } catch (error) {
            console.error('Error parsing datetime value:', error);
        }
    }

    return (
        <>
            <Col span={4} key={item?.name + '---start1716367549959---' + index}>
                <Form.Item
                    {...commonProps}
                    name={item?.name + '---start1716367549959---' + index}
                    label={item?.name + ' 起始'}
                    initialValue={startValue}
                >
                    <DatePicker style={{ width: '100%' }} placeholder={item.placeholder} showTime />
                </Form.Item>
            </Col>
            <Col span={4} key={item?.name + '---end1716367549959---' + index}>
                <Form.Item
                    {...commonProps}
                    name={item?.name + '---end1716367549959---' + index}
                    label={item?.name + ' 结束'}
                    initialValue={endValue}
                >
                    <DatePicker style={{ width: '100%' }} placeholder={item.placeholder} showTime />
                </Form.Item>
            </Col>
        </>
    );
    }
  
    if (item.type !== 'DATETIME' && item.type !== 'TIMESTAMP' && item.type !== 'DATE' && item.operator === 'between') {
      if (index === 15) searchButtons = true;
      return <>
        <Col span={4} key={item?.name + '---start1716367549959---' + index}>
          <Form.Item
            {...commonProps}
            name={item?.name + '---start1716367549959---' + index}
            label={item?.name + ' 起始'}
            initialValue={item.value?.start !== undefined && item.value?.start !== null && item.value?.start !== '' ? item.value?.start : undefined} // 设置起始默认值，为空时不填充
          >
            <Input placeholder={item.placeholder} allowClear />
          </Form.Item>
        </Col>
        <Col span={4} key={item?.name + '---end1716367549959---' + index}>
          <Form.Item
            {...commonProps}
            name={item?.name + '---end1716367549959---' + index}
            label={item?.name + ' 结束'}
            initialValue={item.value?.end !== undefined && item.value?.end !== null && item.value?.end !== '' ? item.value?.end : undefined} // 设置结束默认值，为空时不填充
          >
            <Input placeholder={item.placeholder} allowClear />
          </Form.Item>
        </Col>
      </>;
    }
  
    if ((item.type === 'DATETIME' || item.type === 'TIMESTAMP' || item.type === 'DATE') && item.operator !== 'between' && item.operator === 'in') {
      let initialValue = [];

      if (typeof item.value === 'string' && item.value.trim().startsWith('[') && item.value.trim().endsWith(']')) {
          try {
              const parsedValue = JSON.parse(item.value);
              initialValue = Array.isArray(parsedValue)
                  ? parsedValue.map((val) => moment(val, 'YYYY-MM-DD HH:mm:ss'))
                  : [];
          } catch (e) {
              console.error('Failed to parse item.value as JSON:', e);
          }
      } else if (Array.isArray(item.value)) {
          initialValue = item.value.map((val) => moment(val, 'YYYY-MM-DD HH:mm:ss'));
      }

      return (
          <Col span={4} key={item?.name + '---' + index}>
              <Form.Item {...commonProps} name={item?.name + '---' + index} initialValue={initialValue}>
                  <Select
                      placeholder={item.placeholder}
                      allowClear
                      mode="multiple"
                      showArrow
                      onDropdownVisibleChange={(open) => this.getOptions(open, item?.name)}
                      options={selectOptions[item?.name]}
                      loading={selectLoading}
                  />
              </Form.Item>
          </Col>
      );
    }
  
    if ((item.type === 'DATETIME' || item.type === 'TIMESTAMP') && item.operator !== 'between' && item.operator !== 'in') {
      return (
          <Col span={4} key={item?.name + '---' + index}>
              <Form.Item
                  {...commonProps}
                  name={item?.name + '---' + index}
                  initialValue={item.value ? moment(item.value, 'YYYY-MM-DD HH:mm:ss') : undefined}
              >
                  <DatePicker style={{ width: '100%' }} showTime />
              </Form.Item>
          </Col>
      );
    }

  
    if (item.type !== 'DATETIME' && item.type !== 'TIMESTAMP' && item.type !== 'DATE' && item.operator !== 'between' && item.operator === 'in') {
      let initialValue = [];

      if (typeof item.value === 'string' && item.value.trim().startsWith('[') && item.value.trim().endsWith(']')) {
        try {
          
          const parsedValue = JSON.parse(item.value);
          initialValue = Array.isArray(parsedValue) ? parsedValue : [parsedValue];
        } catch (e) {
          console.error('Failed to parse item.value as JSON:', e);
          initialValue = item.value ? [item.value] : [];
        }
      } else if (Array.isArray(item.value)) {
        initialValue = item.value;
      } else {
        initialValue = item.value ? [item.value] : [];
      }

      return <Col span={4} key={item?.name + '---' + index}>
        <Form.Item
          {...commonProps}
          name={item?.name + '---' + index}
          initialValue={initialValue} // 设置默认值，为空时不填充
        >
          <Select
            placeholder={item.placeholder}
            allowClear
            mode="multiple"
            showArrow
            maxTagCount="responsive"
            onDropdownVisibleChange={open => this.getOptions(open, item?.name)}
            options={selectOptions[item?.name]}
            loading={selectLoading}
            autoClearSearchValue={false}
          />
        </Form.Item>
      </Col>;
    }
    // 2. DATE 且操作符为 between
    if (item.type === 'DATE' && item.operator === 'between') {
      if (index === 15) searchButtons = true;
      return (
          <>
              <Col span={4} key={item?.name + '---start1716367549959---' + index}>
                  <Form.Item
                      {...commonProps}
                      name={item?.name + '---start1716367549959---' + index}
                      label={item?.name + ' 起始'}
                      initialValue={item.value?.start || undefined}
                  >
                      <DatePicker style={{ width: '100%' }} placeholder={item.placeholder} />
                  </Form.Item>
              </Col>
              <Col span={4} key={item?.name + '---end1716367549959---' + index}>
                  <Form.Item
                      {...commonProps}
                      name={item?.name + '---end1716367549959---' + index}
                      label={item?.name + ' 结束'}
                      initialValue={item.value?.end || undefined}
                  >
                      <DatePicker style={{ width: '100%' }} placeholder={item.placeholder} />
                  </Form.Item>
              </Col>
          </>
      );
    }
  
    if (item.type === 'DATE' && item.operator !== 'between' && item.operator !== 'in') {
      return <Col span={4} key={item?.name + '---' + index}>
        <Form.Item
          {...commonProps}
          name={item?.name + '---' + index}
          initialValue={item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined} // 设置默认值，为空时不填充
        >
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
      </Col>;
    }
  
        // 4. DATETIME、TIMESTAMP 或 DATE 且操作符为 single
    if ((item.type === 'DATETIME' || item.type === 'TIMESTAMP' || item.type === 'DATE') && item.operator === 'single') {
    return (
        <Col span={4} key={item?.name + '---' + index}>
            <Form.Item
                {...commonProps}
                name={item?.name + '---' + index}
                initialValue={item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined}
            >
                <Select
                    placeholder={item.placeholder}
                    allowClear
                    showArrow
                    onDropdownVisibleChange={(open) => this.getOptions(open, item?.name)}
                    options={selectOptions[item?.name]}
                    loading={selectLoading}
                />
            </Form.Item>
        </Col>
    );
    }
  
    if (item.type !== 'DATETIME' && item.type !== 'TIMESTAMP' && item.type !== 'DATE' && item.operator !== 'between' && item.operator === 'single') {
      return <Col span={4} key={item?.name + '---' + index}>
        <Form.Item
          {...commonProps}
          name={item?.name + '---' + index}
          initialValue={item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined} // 设置默认值，为空时不填充
        >
          <Select
            placeholder={item.placeholder}
            allowClear
            showArrow
            maxTagCount="responsive"
            onDropdownVisibleChange={open => this.getOptions(open, item?.name)}
            options={selectOptions[item?.name]}
            loading={selectLoading}
          />
        </Form.Item>
      </Col>;
    }

    if (item.type === 'DATE' && item.operator !== 'between' && item.operator !== 'single') {
      return <Col span={4} key={item?.name + '---' + index}>
        <Form.Item
          {...commonProps}
          name={item?.name + '---' + index}
          initialValue={item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined} // 设置默认值，为空时不填充
        >
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
      </Col>;
    }

    if (item.operator === 'likes') {
      
      return <Col span={4} key={item?.name + '---' + index}>
        <Form.Item
          {...commonProps}
          name={item?.name + '---' + index}
        >
          <Select
            className='select-tag-style'
            mode="tags"
            placeholder={item.placeholder}
            allowClear
            open={false}
            defaultValue={item.value?.map(val => val) || []} // 设置默认值，为空时不填充
            style={{ width: '100%' }}
            options={[]}
          />
        </Form.Item>
      </Col>;
    }
      
    return <Col span={4} key={item?.name + '---' + index}>
        <Form.Item
          {...commonProps}
          name={item?.name + '---' + index}
          initialValue={item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined} // 设置默认值，为空时不填充
        >
          <Input placeholder={item.placeholder} allowClear />
        </Form.Item>
      </Col>;
    });
  
    return { finalArray, searchButtons };
  }
  render() {
    const {marketingResourcePoolStore, record, poolObj, t} = this.props
    const {reportPageCondition} = marketingResourcePoolStore
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <Row gutter={[10, 0]}>
            {this.renderSearchCriteria()['finalArray']}
            <Col flex="auto" style={{
              textAlign: 'right',
              marginTop: reportPageCondition?.length % 4 === 0 ? 0 : 30,
              marginBottom: reportPageCondition?.length % 4 === 0 ? 10 : 0
            }}>
              <Button onClick={this.handleSearch} style={{marginLeft: 0}} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleSend} type="primary" icon={<SendOutlined />}>多选发送</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <SendFormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancelSend}
          conditions={this.state.conditions}
          idList={this.state.idList}
          poolObj={poolObj}
          record={record}
          type={record?.marketingType}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
